export const campaignTypeLabels = {
  visitation: 'Foot Traffic/Retail Sales Attribution',
  cpg: 'CPG',
  rsl: 'RSL',
  all: 'All',
};

export type CampaignType = keyof typeof campaignTypeLabels;
